import { lazy, Suspense } from "react";

import {
  AuthenticationProvider,
  useAuthenticationContext,
} from "./authentication/authentication.context";
import { ConnectivityStatusProvider } from "./connectivity.context";
import { DataStoreProvider, emptyStoreState } from "./dataStore.context";
import { PageLoadingProvider } from "./page-loading.context";
import { ThemeProvider } from "./theme.provider";
import { ToastProvider } from "./toast.context";

const AuthenticatedServices = lazy(
  () => import("@/components/AuthenticatedServices"),
);

function SessionServices() {
  const { uid, authToken } = useAuthenticationContext();
  return uid && authToken && !authToken.claims.setupRequired ? (
    <Suspense fallback={null}>
      <AuthenticatedServices />
    </Suspense>
  ) : null;
}

/*
 * HOC for cleaning up Context Provider imports
 */
const AllContexts: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  let isDark = false;
  try {
    isDark = localStorage.getItem("theme") === "dark";
  } catch {
    /* Use the default theme. */
  }
  const theme = isDark ? "dark" : "light";

  return (
    <ConnectivityStatusProvider>
      <DataStoreProvider initialData={emptyStoreState}>
        <ThemeProvider
          initialValues={{
            theme: theme,
          }}
        >
          <ToastProvider>
            <AuthenticationProvider>
              <SessionServices />
              <PageLoadingProvider>{children}</PageLoadingProvider>
            </AuthenticationProvider>
          </ToastProvider>
        </ThemeProvider>
      </DataStoreProvider>
    </ConnectivityStatusProvider>
  );
};

export default AllContexts;
